import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGEVIEW_EVENT_ID = process.env.REACT_APP_X_PAGEVIEW_EVENT_ID;
const SIGNUP_EVENT_ID = process.env.REACT_APP_X_SIGNUP_EVENT_ID;

const PENDING_SIGNUP_KEY = 'x_pixel_pending_signup';
const trackedKey = (userId) => `x_pixel_signup_tracked_${userId}`;

const devLog = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('[X Pixel]', ...args);
  }
};

export const trackPixelEvent = (eventId, params = {}) => {
  if (!eventId) return;
  if (typeof window.twq !== 'function') {
    devLog('twq not available (blocked or not loaded), skipping event', eventId);
    return;
  }
  window.twq('event', eventId, params);
  devLog('event fired:', eventId, params);
};

export const queueSignupConversion = (userId) => {
  if (!userId || localStorage.getItem(trackedKey(userId))) return;
  localStorage.setItem(PENDING_SIGNUP_KEY, userId);
  devLog('signup conversion queued for', userId);
};

const firePendingSignupConversion = () => {
  const userId = localStorage.getItem(PENDING_SIGNUP_KEY);
  if (!userId) return;
  localStorage.removeItem(PENDING_SIGNUP_KEY);
  if (localStorage.getItem(trackedKey(userId))) return;
  trackPixelEvent(SIGNUP_EVENT_ID, { value: 0, currency: 'CAD' });
  localStorage.setItem(trackedKey(userId), '1');
};

export const usePixelPageView = () => {
  const location = useLocation();

  useEffect(() => {
    firePendingSignupConversion();
  }, []);

  useEffect(() => {
    trackPixelEvent(PAGEVIEW_EVENT_ID, {});
  }, [location.pathname]);
};
